import { useFetchServicePreferences } from '@/hooksApi';
import useUserStore, { selectUsesServices } from '@/stores/userStore';

/**
 * SVC-STEP — is there actually a service for the merchant to choose between?
 *
 * ONE SOURCE, on purpose. Three places need this answer — the create-order
 * navigation, the edit-order navigation, and the stepper rail that has to
 * agree with both — and the first cut of this feature let the stepper decide
 * for itself. It rendered "Select Service" on a box with one live service, the
 * flow correctly skipped the step, and the summary then painted a step the
 * merchant had never seen as completed (QA SVC-F2). Two readers of one
 * decision drift the moment ops deactivates a service.
 *
 * A COUNT, not a feature flag: the catalogue is runtime data. An unseeded box
 * has one live service or none, and must keep the wizard it has today.
 */
const useHasServiceChoice = (): boolean => {
  const { data } = useFetchServicePreferences();
  // A merchant with no plan (uses_services=false) has no service at all, so the
  // step is skipped everywhere this answer is read: both navigations, the
  // rail, the summary breadcrumb and its [Change] link.
  const usesServices = useUserStore(selectUsesServices);
  if (!usesServices) return false;

  // BOXY-612 — same rule as the merchant app: only a CONFIRMED single service
  // means "nothing to choose". A catalogue still loading (just signed in) or
  // failed is unknown, and an unknown must not skip the step.
  return data?.services ? data.services.length >= 2 : true;
};

export default useHasServiceChoice;
